import * as datepicker from 'js-datepicker';
import * as moment from 'moment-timezone';
import '../../node_modules/jquery-timepicker/jquery.timepicker';

const { __ } = wp.i18n;

/**
 * IE11 doesn't have a native datepicker
 * Let's provide it for that old fart
 * 
 * @note Also adds a timepicker
 */
class Datepicker {
  constructor() {
    this.timeField = $('.qp-timepicker');
    this.departureField = '#qp-departure-date';
    this.arrivalField = '#qp-arrival-date';
    this.defaultOptions = {
      startDay: 1,
      minDate: new Date(),
      showAllDates: true,
      position: 'tl',
      formatter: (input, date) => {
        /* eslint-disable no-param-reassign */
        input.value = moment(date).format('DD-MM-YYYY');
        /* eslint-enable no-param-reassign */
      },
      onSelect: (instance) => {
        $(instance.el).trigger('change');
      },
      customDays: [
        __('zo', 'quickparking'),
        __('ma', 'quickparking'),
        __('di', 'quickparking'),
        __('wo', 'quickparking'),
        __('do', 'quickparking'),
        __('vr', 'quickparking'),
        __('za', 'quickparking'),
      ],
      customMonths: [
        __('januari', 'quickparking'),
        __('februari', 'quickparking'),
        __('maart', 'quickparking'),
        __('april', 'quickparking'),
        __('mei', 'quickparking'),
        __('juni', 'quickparking'),
        __('juli', 'quickparking'),
        __('augustus', 'quickparking'),
        __('september', 'quickparking'),
        __('oktober', 'quickparking'),
        __('november', 'quickparking'),
        __('december', 'quickparking'),
      ],
    };
  }

  init() {
    this.setDeparturePicker();
    this.setArrivalPicker();
    this.setTimepicker();
  }

  setDeparturePicker() {
    const options = this.defaultOptions;
    datepicker(this.departureField, options);
  }

  setArrivalPicker() {
    const options = this.defaultOptions;
    datepicker(this.arrivalField, options);
  }

  setTimepicker() {
    this.timeField.timepicker({
      timeFormat: 'H:mm',
      interval: 60,
      dropdown: true,
      scrollbar: false,
      zindex: 20,
      dynamic: false,
      change: () => {
        this.timeField.trigger('change');
      },
    });
  }
}

$(document).ready(() => new Datepicker().init());
